document.addEventListener('DOMContentLoaded', function() {
  const quickviewModal = document.getElementById('quickview-modal');
  const quickviewClose = document.querySelector('.quickview-close');
  const quickviewContainer = document.querySelector('.quickview-container');
  
  // Default translations - can be overridden by window.quickviewTranslations
  const defaultTranslations = {
    loading: 'Učitava...',
    add_to_cart: 'Dodaj u korpu',
    preorder: 'Prednarudžba',
    buy_now: 'Kupi odmah',
    build_your_own: 'Kreiraj svoj dres',
    sold_out: 'Rasprodano',
    unavailable: 'Nedostupno',
    out_of_stock: 'Nema na stanju',
    view_product: 'Pogledaj sve detalje',
    size: 'Veličina',
    color: 'Boja',
    error_loading: 'Greška pri učitavanju proizvoda. Pokušajte ponovo.',
    close: 'Zatvori'
  };
  
  function getTranslation(key) {
    return (window.quickviewTranslations && window.quickviewTranslations[key]) || defaultTranslations[key] || key;
  }

  function escapeHtml(value) {
    const div = document.createElement('div');
    div.textContent = String(value || '');
    return div.innerHTML;
  }

  function escapeAttribute(value) {
    return escapeHtml(value).replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function weglotTextAttributes(source) {
    return `data-weglot-dynamic="text" data-weglot-source="${escapeAttribute(source)}"`;
  }

  function markWeglotDynamicText(element, source) {
    if (!element) return;

    if (!source) {
      element.removeAttribute('data-weglot-dynamic');
      element.removeAttribute('data-weglot-source');
      return;
    }

    element.setAttribute('data-weglot-dynamic', 'text');
    element.setAttribute('data-weglot-source', source);
  }

  function markWeglotDynamicTextNodes(root) {
    if (!root) return;

    const textNodes = [];
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;

        if (!node.nodeValue.trim() || !parent) return NodeFilter.FILTER_REJECT;
        if (parent.closest('script, style, noscript, [data-weglot-no-translate], [data-weglot-dynamic]')) {
          return NodeFilter.FILTER_REJECT;
        }

        return NodeFilter.FILTER_ACCEPT;
      }
    });

    while (walker.nextNode()) textNodes.push(walker.currentNode);

    textNodes.forEach((textNode) => {
      const value = textNode.nodeValue;
      const source = value.trim();
      const leadingWhitespace = value.slice(0, value.indexOf(source));
      const trailingWhitespace = value.slice(value.indexOf(source) + source.length);
      const fragment = document.createDocumentFragment();
      const span = document.createElement('span');

      if (leadingWhitespace) fragment.append(document.createTextNode(leadingWhitespace));
      span.textContent = source;
      markWeglotDynamicText(span, source);
      fragment.append(span);
      if (trailingWhitespace) fragment.append(document.createTextNode(trailingWhitespace));

      textNode.replaceWith(fragment);
    });
  }

  function refreshWeglotDynamic(root = quickviewContainer) {
    if (!root) return;

    root.dispatchEvent(new CustomEvent('fk:dynamic-content:rendered', { bubbles: true, detail: { root } }));

    if (window.fkWeglotDynamic && typeof window.fkWeglotDynamic.refresh === 'function') {
      window.fkWeglotDynamic.refresh(root);
    }
  }
  
  // HTML entity decoder utility
  function decodeHTMLEntities(text) {
    const textArea = document.createElement('textarea');
    textArea.innerHTML = text;
    return textArea.value;
  }
  
  // Safe JSON parser with error handling and HTML decoding
  function safeJSONParse(jsonString) {
    if (!jsonString) return null;
    
    try {
      // First, try to parse as-is
      return JSON.parse(jsonString);
    } catch (e) {
      
      try {
        // Use the browser's built-in HTML entity decoder
        const decodedJson = decodeHTMLEntities(jsonString);
        return JSON.parse(decodedJson);
      } catch (e2) {
        
        try {
          // Manual HTML decode as fallback
          let cleanedJson = jsonString
            // Decode common HTML entities
            .replace(/&quot;/g, '"')
            .replace(/&amp;/g, '&')
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/&#x27;/g, "'")
            .replace(/&#x2F;/g, '/')
            .replace(/&#39;/g, "'")
            // Remove any trailing commas
            .replace(/,(\s*[}\]])/g, '$1')
            // Remove control characters that might break JSON
            .replace(/[\x00-\x1f\x7f-\x9f]/g, '')
            // Fix common malformed JSON patterns
            .replace(/,(\s*$)/gm, '') // trailing commas at end of lines
            .replace(/"\s*:\s*"([^"]*?)\s*=\s*([^"]*?)"/g, '": "$1=$2"') // fix malformed attribute patterns
            // Fix incomplete strings (this is a basic attempt)
            .replace(/"\s*$(?!\s*[,}\]])/gm, '""'); // close unclosed quotes at end of lines
          
          return JSON.parse(cleanedJson);
        } catch (e3) {
          return null;
        }
      }
    }
  }
  
  // Image preloader function
  function preloadImage(src) {
    return new Promise((resolve, reject) => {
      if (!src) {
        resolve(null);
        return;
      }
      
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = () => reject(new Error(`Failed to load image: ${src}`));
      img.src = src;
    });
  }
  
  // Preload multiple images (for variants)
  function preloadImages(imageSources) {
    const uniqueSources = [...new Set(imageSources.filter(src => src))];
    return Promise.allSettled(uniqueSources.map(preloadImage));
  }
  
  function openQuickview(productHandle) {
    if (!productHandle) return;
    
    quickviewContainer.innerHTML = `
      <div class="quickview-loading"></div>
    `;
    
    // Show modal immediately with loading state
    quickviewModal.style.display = 'flex';
    setTimeout(() => {
      quickviewModal.classList.add('active');
    }, 10);
    
    document.body.style.overflow = 'hidden';
    
    loadProductData(productHandle);
  }
  
  function closeQuickview() {
    if (!quickviewModal.classList.contains('active')) return;
    
    quickviewModal.style.display = 'none';
    quickviewModal.classList.remove('active');
    
    setTimeout(() => {
      if (quickviewModal) {
        quickviewModal.style.display = 'none';
        quickviewContainer.innerHTML = '';
      }
    }, 300);
    
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  }
  
  quickviewModal.addEventListener('click', function(e) {
    if (e.target === quickviewModal) {
      closeQuickview();
    }
  });
  
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && quickviewModal.classList.contains('active')) {
      closeQuickview();
    }
  });
  
  if (quickviewClose) {
    quickviewClose.addEventListener('click', closeQuickview);
  }
  
  function loadProductData(handle) {
    const productCard = document.querySelector(`.product-grid-item[data-product-handle="${handle}"]`);
    
    if (productCard && productCard.dataset.productJson) {      
      // Use safe JSON parsing
      const productData = safeJSONParse(productCard.dataset.productJson);
      
      if (productData) {        
        // Collect all image sources for preloading
        const imageSources = [];
        if (productData.featured_image) {
          imageSources.push(productData.featured_image);
        }
        if (productData.variants) {
          productData.variants.forEach(variant => {
            if (variant.featured_image && variant.featured_image.src) {
              imageSources.push(variant.featured_image.src);
            }
          });
        }
        
        // Preload images before rendering
        preloadImages(imageSources).finally(() => {
          renderQuickview(productData);
        });
      } else {
        fetchProductFromAPI(handle);
      }
      
    } else {
      fetchProductFromAPI(handle);
    }
  }
  
  function fetchProductFromAPI(handle) {
    fetch(`/products/${handle}?view=quickview`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
      })
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // More robust data extraction with fallbacks
        const titleElement = doc.querySelector('.product-title') || doc.querySelector('h1') || doc.querySelector('.product__title');
        const descriptionElement = doc.querySelector('.product-description') || doc.querySelector('.product__description');
        const priceElement = doc.querySelector('.price-item--regular') || doc.querySelector('.price') || doc.querySelector('.product__price');
        const imageElement = doc.querySelector('.product__media img') || doc.querySelector('.product img') || doc.querySelector('img');
        const jerseyBuilderLink = doc.querySelector('.pdp-details-jersey-builder-link');
        
        const productData = {
          handle: handle,
          tags: safeJSONParse(doc.querySelector('product-info')?.dataset.productTags || '[]') || [],
          title: titleElement ? titleElement.textContent.trim() : 'Product',
          category: '',
          description: descriptionElement ? descriptionElement.innerHTML : '',
          price: priceElement ? priceElement.textContent.trim() : '',
          variants: [],
          options: [],
          featured_image: imageElement ? imageElement.src : '',
          jersey_builder_url: jerseyBuilderLink ? jerseyBuilderLink.getAttribute('href') : ''
        };
        
        // Extract variant options
        const variantSelects = doc.querySelectorAll('select[name^="option"]');
        variantSelects.forEach(select => {
          const option = {
            name: select.name,
            values: []
          };
          
          select.querySelectorAll('option').forEach(opt => {
            if (opt.value) {
              option.values.push({
                value: opt.value,
                text: opt.textContent.trim()
              });
            }
          });
          
          if (option.values.length > 0) {
            productData.options.push(option);
          }
        });
        
        // Collect all image sources for preloading
        const imageSources = [];
        if (productData.featured_image) {
          imageSources.push(productData.featured_image);
        }
        if (productData.variants) {
          productData.variants.forEach(variant => {
            if (variant.featured_image && variant.featured_image.src) {
              imageSources.push(variant.featured_image.src);
            }
          });
        }
        
        // Preload images before rendering
        preloadImages(imageSources).finally(() => {
          renderQuickview(productData);
        });
      })
      .catch(error => {
        quickviewContainer.innerHTML = `
          <div class="quickview-error">
            <p ${weglotTextAttributes(getTranslation('error_loading'))}>${escapeHtml(getTranslation('error_loading'))}</p>
            <p style="font-size: 0.875rem; opacity: 0.7;">Error: ${error.message}</p>
            <button class="button" onclick="closeQuickview()" ${weglotTextAttributes(getTranslation('close'))}>${escapeHtml(getTranslation('close'))}</button>
          </div>
        `;
        refreshWeglotDynamic(quickviewContainer);
      });
  }
  
  function renderQuickview(product) {
    const locale = Shopify && Shopify.locale ? Shopify.locale : 'hr';
    const productUrl = `${locale === 'hr' ? '' : `/${locale}`}/products/${product.handle}`;
    
    let html = `
      <div class="quickview-images">
        <a href="${productUrl}" class="quickview-image-link">
          <div class="quickview-main-image">
            <img id="quickview-featured-image" src="${product.featured_image || ''}" alt="${escapeAttribute(product.title)}" loading="eager" fetchpriority="high" />
          </div>
        </a>
      </div>
      <div class="quickview-details">
        ${product.category ? `<p class="quickview-eyebrow" ${weglotTextAttributes(product.category)}>${escapeHtml(product.category)}</p>` : ''}
        <h2 class="quickview-title">
          <a href="${productUrl}" class="quickview-title-link" ${weglotTextAttributes(product.title || '')}>${escapeHtml(product.title || '')}</a>
        </h2>
        <div class="quickview-price-wrapper pdp-details-product-price">
          <span class="pdp-member-price-badge" data-member-price-badge hidden ${weglotTextAttributes(window.memberPricing?.label || '')}>${escapeHtml(window.memberPricing?.label || '')}</span>
          <span class="pdp-details-sale-price" id="quickview-price">${escapeHtml(product.price || '')}</span>
          <span class="pdp-details-compare-price" id="quickview-compare-price" hidden></span>
        </div>
        
        <div class="quickview-variants">
          ${renderVariantOptions(product)}
        </div>
        
        ${product.jersey_builder_url ? `
          <div class="quickview-form">
            <a
              href="${escapeAttribute(product.jersey_builder_url)}"
              class="button cta cta-ps-primary quickview-jersey-builder-link"
            >
              <span ${weglotTextAttributes(getTranslation('build_your_own'))}>${escapeHtml(getTranslation('build_your_own'))}</span>
            </a>
          </div>
        ` : `
          <div class="quickview-form">
            <form method="post" action="/cart/add" id="quickview-product-form" class="product-form">
              <input type="hidden" name="id" id="quickview-variant-id" value="">

              <button type="submit" name="add" class="button cta cta-ps-primary quickview-add-to-cart js-go-cart-add-to-cart" id="quickview-add-to-cart">
                <span ${weglotTextAttributes(getTranslation('add_to_cart'))}>${escapeHtml(getTranslation('add_to_cart'))}</span>
              </button>

              <button type="button" class="button cta cta-ps-secondary quickview-buy-now" id="quickview-buy-now">
                <span ${weglotTextAttributes(getTranslation('buy_now'))}>${escapeHtml(getTranslation('buy_now'))}</span>
              </button>
            </form>
          </div>
        `}
        
        ${product.description ? `<div class="quickview-description">${product.description}</div>` : ''}
        <a href="${productUrl}" class="quickview-view-details" ${weglotTextAttributes(getTranslation('view_product'))}>${escapeHtml(getTranslation('view_product'))}</a>
      </div>
    `;
    
    quickviewContainer.innerHTML = html;

    markWeglotDynamicTextNodes(quickviewContainer.querySelector('.quickview-description'));
    
    initVariantSelection(product);
    
    document.dispatchEvent(new CustomEvent('quickview:loaded'));
    refreshWeglotDynamic(quickviewContainer);
    
    const addToCartBtn = document.querySelector('#quickview-add-to-cart');
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', () => {
        setTimeout(closeQuickview, 300);
      });
    }

    const buyNowButton = document.querySelector('#quickview-buy-now')

    if(buyNowButton) {
      buyNowButton.addEventListener('click', (e) => {
        e.preventDefault();

        const variantId = document.getElementById('quickview-variant-id').value ?? null;
        const quantity = 1;

        if (!variantId || buyNowButton.disabled) {
          return;
        }

        window.location.href = `/cart/${variantId}:${quantity}?checkout`;
      })
    }
  }
  
  function renderVariantOptions(product) {
    if (!product.options || product.options.length === 0) return '';
    
    let html = '';
    
    product.options.forEach((option, index) => {
      const optionName = option.name.replace('option', '');
      const isColor = optionName.toLowerCase().includes('boja') || optionName.toLowerCase().includes('color');
      const isSize = optionName.toLowerCase().includes('veličina') || optionName.toLowerCase().includes('size');
      
      const displayName = isSize ? getTranslation('size') : (isColor ? getTranslation('color') : optionName);
      
      html += `
        <div class="product-form__input product-form__input--${isColor ? 'swatch' : 'dropdown'}">
          <label class="form__label" for="Option-quickview-${index}">
            <span ${weglotTextAttributes(`${displayName}:`)}>${escapeHtml(displayName)}:</span>
            <span class="value-selected" id="value-selected-${index}"></span>
          </label>
          <div class="input-selector-wrapper">
      `;
      
      option.values.forEach((value, valueIndex) => {
        const inputId = `quickview-option-${index}-${valueIndex}`;
        
        let colorValue = null;
        if (isColor && product.variants) {
          const variant = product.variants.find(v => v.options && v.options[index] === value.value);
          if (variant && variant.color) {
            colorValue = variant.color;
          }
        }

        const visibleLabel = isColor && colorValue ? '' : value.text;
        
        html += `
          <div class="input-selector ${isColor ? 'color' : ''} ${isSize ? 'size' : ''}">
            <input type="radio" 
                  id="${inputId}" 
                  name="option-${index}" 
                  value="${value.value}" 
                  data-text="${value.text}"
                  ${valueIndex === 0 ? 'checked' : ''}
                  class="visually-hidden">
            <label for="${inputId}" class="product-variant-label ${colorValue ? 'has-color' : 'no-color'}" ${colorValue ? `style="background-color: ${colorValue};"` : ''} ${visibleLabel ? weglotTextAttributes(visibleLabel) : ''}>
              ${escapeHtml(visibleLabel)}
            </label>
          </div>
        `;
      });
      
      html += `
          </div>
        </div>
      `;
    });
    
    return html;
  }
  
  function initVariantSelection(product) {
    if (!product.variants || product.variants.length === 0) return;
    
    const variantRadios = document.querySelectorAll('.input-selector input[type="radio"]');
    const variantIdInput = document.getElementById('quickview-variant-id');
    const addToCartBtn = document.getElementById('quickview-add-to-cart');
    const priceElement = document.getElementById('quickview-price');
    
    variantRadios.forEach(radio => {
      radio.addEventListener('change', updateVariantSelection);
    });
    
    function updateVariantSelection() {
      const selectedValues = [];
      
      document.querySelectorAll('.quickview-container .input-selector-wrapper').forEach((wrapper, index) => {
        const selectedRadio = wrapper.querySelector('input[type="radio"]:checked');
        const valueSelectedSpan = document.getElementById(`value-selected-${index}`);
        
        if (selectedRadio && valueSelectedSpan) {
          selectedValues.push(selectedRadio.value);
          const selectedText = selectedRadio.dataset.text || selectedRadio.value;
          valueSelectedSpan.textContent = selectedText;
          markWeglotDynamicText(valueSelectedSpan, selectedText);
        }
      });
      
      const selectedVariant = product.variants.find(variant => {
        return variant.options && variant.options.every((option, index) => {
          return option === selectedValues[index];
        });
      });

      const buyNowButton = document.querySelector('#quickview-buy-now');
      
      if (selectedVariant) {
        const displayPrice = window.memberPricing?.getDisplayPrice
          ? window.memberPricing.getDisplayPrice(selectedVariant, product.tags || [])
          : {
              price: selectedVariant.price,
              compareAtPrice: selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price ? selectedVariant.compare_at_price : null,
              isMemberPrice: false,
            };

        if (variantIdInput) {
          variantIdInput.value = selectedVariant.id;
        }
        
        if (priceElement) {
          if (selectedVariant.price) {
            priceElement.textContent = window.formatMoney ? window.formatMoney(displayPrice.price) : displayPrice.price;
          }
          
          const comparePriceElement = document.getElementById('quickview-compare-price');
          const memberPriceBadgeElement = document.querySelector('.quickview-container [data-member-price-badge]');
          if (displayPrice.compareAtPrice) {
            comparePriceElement.textContent = window.formatMoney ? window.formatMoney(displayPrice.compareAtPrice) : displayPrice.compareAtPrice;
            comparePriceElement.hidden = false;
          } else {
            comparePriceElement.hidden = true;
          }

          if (memberPriceBadgeElement) {
            memberPriceBadgeElement.hidden = !displayPrice.isMemberPrice;
          }
        }
        
        // Handle variant image switching
        if (selectedVariant.featured_image && selectedVariant.featured_image.src) {
          updateQuickviewImages(selectedVariant.featured_image, product.media);
        }
        
        if (addToCartBtn) {
          if (selectedVariant.available) {
            addToCartBtn.disabled = false;
            setButtonText(addToCartBtn, getTranslation(selectedVariant.preorder ? 'preorder' : 'add_to_cart'));
          } else {
            addToCartBtn.disabled = true;
            setButtonText(addToCartBtn, getTranslation('sold_out'));
          }
        }

        if (buyNowButton) {
          if (selectedVariant.available) {
            buyNowButton.style.display = 'block';
            buyNowButton.disabled = false;
            setButtonText(buyNowButton, getTranslation('buy_now'));
          } else {
            buyNowButton.style.display = 'none';
            buyNowButton.disabled = true;
            setButtonText(buyNowButton, getTranslation('sold_out'));
          }
        }
      } else {
        if (addToCartBtn) {
          addToCartBtn.disabled = true;
          setButtonText(addToCartBtn, getTranslation('unavailable'));
        }
        if (buyNowButton) {
          buyNowButton.style.display = 'none';
          buyNowButton.disabled = true;
          setButtonText(buyNowButton, getTranslation('unavailable'));
        }
      }

      refreshWeglotDynamic(quickviewContainer);
    }
    
    updateVariantSelection();
  }

  function setButtonText(button, text) {
    const label = button && button.querySelector('span');
    if (!label) return;

    label.textContent = text;
    markWeglotDynamicText(label, text);
  }

  // New function to update quickview images when variant changes
  function updateQuickviewImages(variantImage, allMedia) {
    if (!variantImage || !variantImage.src) return;
    
    // Update main featured image
    const featuredImage = document.getElementById('quickview-featured-image');
    if (featuredImage) {
      featuredImage.src = variantImage.src;
      featuredImage.srcset = `${variantImage.src} 1x, ${variantImage.src} 2x`;
    }
  }

  // Advanced preloading: Preload images when user hovers over product cards
  function initHoverPreloading() {
    const productCards = document.querySelectorAll('.product-grid-item[data-product-handle]');
    
    productCards.forEach(card => {
      let preloadTimeout;
      
      card.addEventListener('mouseenter', () => {
        // Delay preloading slightly to avoid preloading on quick mouse passes
        preloadTimeout = setTimeout(() => {
          const handle = card.dataset.productHandle;
          if (handle && card.dataset.productJson) {
            const productData = safeJSONParse(card.dataset.productJson);
            
            if (productData) {
              // Collect and preload images
              const imageSources = [];
              if (productData.featured_image) {
                imageSources.push(productData.featured_image);
              }
              if (productData.variants) {
                productData.variants.forEach(variant => {
                  if (variant.featured_image && variant.featured_image.src) {
                    imageSources.push(variant.featured_image.src);
                  }
                });
              }
              
              // Preload in background
              preloadImages(imageSources).catch(() => {
                // Silently handle preload failures
              });
            }
          }
        }, 150);
      });
      
      card.addEventListener('mouseleave', () => {
        if (preloadTimeout) {
          clearTimeout(preloadTimeout);
        }
      });
    });
  }
  
  setTimeout(initHoverPreloading, 1000);

  window.openQuickview = function(productHandle) {
    openQuickview(productHandle);
  };
  
  window.closeQuickview = closeQuickview;
});
